export default __webpack_public_path__ + "static/media/logo-alianca-plus-white-text.3895c877.svg";